export default __webpack_public_path__ + "7edb96ec37544296008b905dbf9cc31b.png";